export const SUBSCRIBE_DOMAINS_OVER_LIMIT_ERROR = "si.management.subscribe-domains.upload.overLimit.error";
export const SUBSCRIBE_DOMAINS_COL_NUMBER_ERROR = "si.management.subscribe-domains.upload.columnsNumber.error";
export const SUBSCRIBE_DOMAINS_NOT_A_DOMAINS_ERROR = "si.management.subscribe-domains.upload.notADomains.error";
export const SUBSCRIBE_DOMAINS_FORMAT_ERROR = "si.management.subscribe-domains.upload.format.error";
